module.exports = __webpack_public_path__ + "static/newsgazette-a5361549e3650610bbf819a45c0e861d.png";